import { Component } from 'react'
import { graphql, compose } from 'react-apollo'

import { $ } from 'utils'
import { Loader } from 'components'
import { IDENTIFY_PERSON } from 'queries/matching'
import { withConsumer } from 'store'

import Results from './Results'

class IdentifyPerson extends Component {

  render() {
    const { closeBottomPanel, type, matchType, data: { loading, identify, error, person } } = this.props
    if (loading) return $(Loader)

    return (
      $(Results, { closeBottomPanel, type, matchType, results: identify, source: person, loading, error })
    )
  }
}

export default compose(
  graphql(IDENTIFY_PERSON, {
    options: props => ({
      variables: {
        fetchPolicy: 'cache-and-network',
        personId: props.personId,
        limit: +props.limit,
        listId: props.listId,
        personIds: props.personIds
      }
    })
  })
)(withConsumer(IdentifyPerson, '/persons'))




// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/IdentifyPerson.js